import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  useSearchState,
  useSearchDispatch,
} from '../../../hooks/use_search_state';
import { findKind } from '../../../utils/finders';
import FilterButton from './filter_button';

export default function Categories(props) {
  const {
    toggle,
    unfilteredResults,
    loading,
    settings,
  } = props;

  const {
    category,
    customCategory,
  } = useSearchState();

  const {
    setCategory,
    setCustomCategory,
  } = useSearchDispatch();

  const { customCategories } = settings;
  const categories = useMemo(() => findKind(unfilteredResults, 'strCategoryName', 'strCategoryName'), [unfilteredResults]);

  return (
    <div className="snapgadget-search-facet snapgadget-search-facet-categories">
      <div className="snapgadget-search-facet-contents">
        <h2>Categories</h2>
        {
          loading || unfilteredResults.length === 0
            ? null
            : customCategories?.map((curCategory) => (
              <FilterButton
                selected={customCategory === curCategory.query}
                key={curCategory.name}
                name={curCategory.name}
                onClick={() => toggle(curCategory.query, setCustomCategory, customCategory)}
              />
            ))
        }
        {loading
          ? <div className="snapgadget-search-facet-group">Loading categories</div>
          : categories.map((curCategory) => (
            <FilterButton
              selected={category === curCategory.ids[0]}
              key={curCategory.name}
              name={curCategory.name}
              onClick={() => toggle(curCategory.ids[0], setCategory, category)}
            />
          ))}

      </div>
    </div>
  );
}

Categories.propTypes = {
  toggle: PropTypes.func.isRequired,
  unfilteredResults: PropTypes.arrayOf(PropTypes.shape({
    lngMerchantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  loading: PropTypes.bool,
  settings: PropTypes.shape({
    customCategories: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      query: PropTypes.string.isRequired,
    })),
  }),
};

Categories.defaultProps = {
  unfilteredResults: [],
  loading: false,
  settings: {
    customCategories: [],
  },
};
